/* DIVICE : mini-panier au survol + tailles sur les cartes produits */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
  var lang = document.documentElement.lang || 'fr';
  var canHover = window.matchMedia('(hover: hover)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  /* ---------- Mini-panier (survol de l'icône panier) ---------- */
  var wrap = document.getElementById('DvCart');
  var panel = document.getElementById('DvMinicart');
  var closeTimer = null;
  var autoTimer = null;

  function renderCart(cart) {
    if (!panel) return;
    var html = '<div class="dv-minicart__box">';
    if (!cart.item_count) {
      html += '<p class="dv-minicart__empty">Ton panier est vide</p>' +
        '<a class="dv-minicart__cta" href="' + esc(root + 'collections/all') + '">Découvrir la collection</a>';
    } else {
      html += '<div class="dv-minicart__head">Panier <span>(' + cart.item_count + ')</span></div><ul class="dv-minicart__list">';
      cart.items.forEach(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var meta = [];
        if (it.variant_title) meta.push(esc(it.variant_title));
        meta.push('× ' + it.quantity);
        html += '<li><a class="dv-minicart__item" href="' + esc(it.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="dv-minicart__ph"></span>') +
          '<span class="dv-minicart__info"><span class="dv-minicart__name">' + esc(it.product_title) + '</span>' +
          '<span class="dv-minicart__meta">' + meta.join(' · ') + '</span></span>' +
          '<span class="dv-minicart__price">' + money(it.final_line_price, cart.currency) + '</span></a></li>';
      });
      html += '</ul><div class="dv-minicart__total"><span>Sous-total</span><strong>' +
        money(cart.items_subtotal_price, cart.currency) + '</strong></div>' +
        '<a class="dv-minicart__cta" href="' + esc(cartUrl) + '">Voir le panier</a>';
    }
    panel.innerHTML = html + '</div>';
  }

  function loadCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function openCart() {
    if (!wrap || !panel) return;
    clearTimeout(closeTimer);
    panel.hidden = false;
    wrap.classList.add('is-open');
    loadCart();
  }

  function closeCart() {
    if (!wrap || !panel) return;
    clearTimeout(autoTimer);
    panel.hidden = true;
    wrap.classList.remove('is-open');
  }

  if (wrap && panel) {
    if (canHover) {
      wrap.addEventListener('mouseenter', function () { clearTimeout(autoTimer); openCart(); });
      wrap.addEventListener('mouseleave', function () { clearTimeout(closeTimer); closeTimer = setTimeout(closeCart, 250); });
    }
    wrap.addEventListener('focusin', openCart);
    wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) closeCart(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  /* Ouvre le mini-panier quelques secondes après un ajout */
  function flashCart() {
    if (!wrap || !panel) return;
    openCart();
    clearTimeout(autoTimer);
    autoTimer = setTimeout(closeCart, 3500);
  }

  function updateBubble(sections) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !sections || !sections['cart-icon-bubble']) return;
    var src = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    if (src) el.innerHTML = src.innerHTML;
  }

  /* ---------- Tailles sur les cartes produits ---------- */
  var SIZE_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl', '4xl'];
  var cache = {};

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function rank(val) {
    var i = SIZE_ORDER.indexOf(String(val).toLowerCase());
    if (i > -1) return i;
    var n = parseFloat(val);
    return 100 + (isNaN(n) ? 0 : n);
  }

  function button(label, variant, aria, wide) {
    return '<button type="button" class="dv-size' + (wide ? ' dv-size--wide' : '') + '" data-variant="' + variant.id +
      '" data-label="' + esc(label) + '" aria-label="' + esc(aria) + '">' + esc(label) + '</button>';
  }

  function buildSizes(p) {
    var opts = (p.options || []).map(function (o, i) { return typeof o === 'string' ? { name: o, position: i + 1 } : o; });
    var sizeOpt = opts.filter(function (o) { return /^(taille|size|pointure)/i.test(o.name); })[0];
    var pos = sizeOpt ? sizeOpt.position : (opts.length === 1 && !/^title$/i.test(opts[0].name) ? 1 : 0);
    var html = '';

    if (pos) {
      var order = [];
      var byVal = {};
      p.variants.forEach(function (v) {
        var val = v['option' + pos];
        if (!(val in byVal)) { byVal[val] = null; order.push(val); }
        if (v.available && !byVal[val]) byVal[val] = v;
      });
      var avail = order.filter(function (val) { return byVal[val]; });
      if (sizeOpt) avail.sort(function (a, b) { return rank(a) - rank(b); });
      avail.forEach(function (val) {
        html += button(val, byVal[val], 'Ajouter ' + p.title + ' – ' + val + ' au panier', false);
      });
    } else if (p.variants.length === 1) {
      if (p.variants[0].available) html = button('Ajouter au panier', p.variants[0], 'Ajouter ' + p.title + ' au panier', true);
    } else {
      return null;
    }

    var box = document.createElement('div');
    box.className = 'dv-sizes';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Ajouter au panier');
    box.innerHTML = html || '<span class="dv-sizes__soldout">Épuisé</span>';
    return box;
  }

  function enhance(wrapper) {
    var inner = wrapper.querySelector('.card__inner');
    var link = wrapper.querySelector('a[href*="/products/"]');
    if (!inner || !link) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;

    /* Lien transparent sur l'image : le clic sur l'image ouvre toujours la fiche produit */
    if (!inner.querySelector('.dv-cover')) {
      var cover = document.createElement('a');
      cover.className = 'dv-cover';
      cover.href = link.getAttribute('href');
      cover.setAttribute('aria-hidden', 'true');
      cover.tabIndex = -1;
      inner.appendChild(cover);
    }
    wrapper.setAttribute('data-dv-ready', '1');

    getProduct(m[1]).then(function (p) {
      if (!p || inner.querySelector('.dv-sizes')) return;
      var box = buildSizes(p);
      if (box) inner.appendChild(box);
    });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.unobserve(e.target); enhance(e.target); }
        });
      }, { rootMargin: '300px' })
    : null;

  function scan() {
    document.querySelectorAll('.product-card-wrapper:not([data-dv])').forEach(function (w) {
      w.setAttribute('data-dv', '1');
      if (io) io.observe(w); else enhance(w);
    });
  }

  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(function () { scanQueued = false; scan(); }, 50);
  }

  /* Clic sur une taille : ajout direct au panier */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.dv-size');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var label = btn.getAttribute('data-label');
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(btn.getAttribute('data-variant')),
        quantity: 1,
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'error');
        updateBubble(res.j.sections);
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓';
        flashCart();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.title = err && err.message ? err.message : '';
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.disabled = false;
        }, 1600);
      });
  }, true);

  function init() {
    scan();
    if ('MutationObserver' in window) {
      new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.DvCart = { open: openCart, close: closeCart, flash: flashCart };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();